<template>
  <v-container fluid class="pt-0 mt-0">
    <v-row>
      <v-spacer />
      <v-col cols="12" md="11">
        <v-card class="mx-auto">
          <v-toolbar color="teal" dark class="text-xs-center">
            <v-toolbar-title style="color: white">{{ pageTitle }}</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-text-field
              v-model="searchText"
              hide-details
              label="Enter search text"
              class="ma-0 pa-0"
            >
            </v-text-field>

            <v-btn icon>
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="black-text">
            The news pages contain reviews of European Palm Society visits and meetings
            and articles about growing exotic plants.
            <br />If you have something plant related that you think is news-worthy, then
            please
            <router-link to="/contact">Contact Us</router-link>
          </v-card-text>
        </v-card>
      </v-col>
      <v-spacer />
    </v-row>

    <v-row>
      <v-spacer />
      <v-col cols="12" md="11">
        <v-timeline dense>
          <v-timeline-item v-if="!filteredAPIData">
            <v-card>
              <v-card-title> Loading... </v-card-title>
            </v-card>
          </v-timeline-item>
          <v-timeline-item v-if="filteredAPIData && filteredAPIData.length === 0">
            <v-card>
              <v-card-title> No News Matching Search </v-card-title>
            </v-card>
          </v-timeline-item>
          <v-timeline-item
            v-for="article in filteredAPIData"
            :key="article.id"
            color="blue"
            small
          >
            <v-card class="elevation-2">
              <v-card-title
                :class="'headline font-weight-dark mb-4 blue--text'"
                style="word-break: break-word"
                v-html="article.title"
                @click="showDialog(article)"
              ></v-card-title>
              <v-card-subtitle class="black-text">
                <b>{{ formatDateTime(article.postedDateTime) }}</b>
              </v-card-subtitle>
              <v-card-text v-if="article" style="overflow: hidden" class="black-text"
                ><span v-html="atMax3Paragraphs(properlyDecodeNewsText(article))"
              /></v-card-text>
              <v-card-text class="text-right ma-0 pa-0">
                <v-btn class="ma-2" outlined @click="showDialog(article)">
                  {{ readArticleLabelText() }}
                  <i
                    aria-hidden="true"
                    class="v-icon notranslate v-icon--right mdi mdi-magnify theme--light"
                    style="font-size: 16px"
                  ></i>
                </v-btn>
              </v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </v-col>
      <v-spacer />
    </v-row>

    <v-row class="text-center">
      <v-spacer />
      <v-col cols="11" md="8">
        <v-dialog v-if="this.selectedArticle" v-model="dialog" ref="newsArticle">
          <v-card ref="articleDetailCard">
            <v-card-title
              class="pa-4 headline lighten-2 white--text teal"
              style="word-break: break-word"
            >
              {{ this.selectedArticle.title }}
              <v-card-subtitle class="pa-2 white--text">
                {{ formatDateTime(this.selectedArticle.postedDateTime) }}
              </v-card-subtitle>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="closeDialog()">Close</v-btn>
            </v-card-title>

            <v-card-text class="pa-8 black-text" style="overflow: hidden"
              ><span v-html="properlyDecodeNewsText(selectedArticle)"
            /></v-card-text>

            <v-card-text v-if="selectedArticle.image1">
              <v-card-title class="black-text"> {{ selectedArticle.imageTitle1 }}</v-card-title>
              <v-img
                outlined
                max-height="800px"
                contain
                :src="getOldImageUrl(selectedArticle.image1)"
              />
            </v-card-text>

            <v-card-text v-if="selectedArticle.image2">
              <v-card-title class="black-text"> {{ selectedArticle.imageTitle2 }}</v-card-title>
              <v-img
                outlined
                max-height="800px"
                contain
                :src="getOldImageUrl(selectedArticle.image2)"
              />
            </v-card-text>

            <v-row v-if="selectedArticle.images">
              <v-spacer />
              <v-col
                v-for="image in selectedArticle.images"
                :key="image.imageUrl"
                :sm="getSmSizeForImage(image, selectedArticle.images)"
              >
                <v-card class="mx-auto ml-2 mr-2" elevation="16">
                  <v-card-text>
                    <v-card-title style="word-break: break-word">
                      {{ image.imageCaption }} </v-card-title>
                    <v-img
                      class="ml-auto"
                      outlined
                      :src="getImageFullUrl(image.imageUrl)"
                      eager
                      max-height="100%"
                      max-width="100%"
                    />
                  </v-card-text>
                </v-card>
              </v-col>
              <v-spacer />
            </v-row>

            <v-divider></v-divider>

            <v-card-title class="pa-4 headline lighten-2 white--text teal">
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="closeDialog()">Close</v-btn>
            </v-card-title>
          </v-card>
        </v-dialog>
      </v-col>
      <v-spacer />
    </v-row>
  </v-container>
</template>

<script>
import dateFunctions from "@/functions/dateFunctions";
import stringFunctions from "@/functions/stringFunctions";
import userFunctions from "@/functions/userFunctions";
import forumFunctions from "@/functions/forumFunctions";

export default {
  name: "News",
  methods: {
    getOldImageUrl(image) {
      let imageFolder = "newsimages/"
      return forumFunctions.getImageFullUrl(imageFolder + image);
    },
    getImageFullUrl(imagePath) {
      return forumFunctions.getImageFullUrl(imagePath);
    },
    getSmSizeForImage(image, postImages) {
      let index = postImages.indexOf(image);
      return index === postImages.length - 1 && index % 2 === 0 ? "6" : "6"; //was 12, but single images are massive!
    },
    getArticleSummary(articleContent) {
      return articleContent.substring(0, 250);
    },
    formatDateTime(datetime) {
      return dateFunctions.formatPalmDateTime(datetime);
    },
    atMax3Paragraphs(text) {
      return stringFunctions.atMax3Paragraphs(text);
    },
    properlyDecodeNewsText(item) {
      return item.id <= 62 ? this.htmlDecode(item.content) : item.content;
    },
    htmlDecode(input) {
      var doc = new DOMParser().parseFromString(input, "text/html");
      return doc.documentElement.textContent;
    },
    showDialog(newsPost) {
      this.selectedArticle = newsPost;
      this.dialog = true;
    },
    closeDialog() {
      this.$refs["articleDetailCard"].$el.scrollIntoView(true);
      this.dialog = false;
    },
    listShouldBeCompacted() {
      return (
        this.$vuetify.breakpoint.name === "xs" || this.$vuetify.breakpoint.name === "ms"
      );
    },
    readArticleLabelText() {
      if (this.listShouldBeCompacted()) {
        return "Read";
      } else {
        return "Read Full Article";
      }
    },
    async getAPIData() {
      const res = await fetch(process.env.VUE_APP_SERVER_URL + "/getAllNews", {
        method: "get",
      });
      const data = await res.json();
      this.apiData = data.result;
      userFunctions.updateLastViewed("news");
    },
  },
  data: () => ({
    dialog: false,
    selectedArticle: null,
    apiData: null,
    searchText: "",
  }),
  computed: {
    pageTitle() {
      return this.$vuetify.breakpoint.smAndDown ? "News" : "European Palm Society News";
    },
    filteredAPIData: function () {
      if (!this.searchText || this.searchText.length == 0) {
        return this.apiData;
      }
      if (this.apiData) {
        return this.apiData.filter(
          (article) => (article.title + article.content).indexOf(this.searchText) > 1
        );
      }
      return null;
    },
  },
  beforeMount() {
    this.getAPIData();
  },
};
</script>

<style scoped>
.palm-site-green {
  background-color: rgb(176, 217, 173);
}
</style>
